// 循環参照を避けるため、このモジュールは葉モジュールとして保つ（他domainモジュールへの import を追加しない）
export interface NamedHotel {
  name: string | null | undefined;
}

export const splitNameKeywords = (keyword: string | null | undefined): string[] =>
  (keyword ?? '').split(/\s+/).filter(k => k.length > 0);

export const matchesHotelName = (name: string | null | undefined, keywords: string[]): boolean => {
  if (keywords.length === 0) return true;
  if (!name) return false;

  const target = name.toLowerCase();
  return keywords.every(k => target.includes(k.toLowerCase()));
};

export const filterHotelsByName = <T extends NamedHotel>(hotels: T[], keyword: string | null | undefined): T[] => {
  const keywords = splitNameKeywords(keyword);
  if (keywords.length === 0) return hotels;

  return hotels.filter(h => matchesHotelName(h.name, keywords));
};
